import getShimmerLoadingData from '../shimmer/getShimmerLoadingData';

const getParsedData = (shimmer, columns, data) =>
  shimmer && shimmer.loading ? getShimmerLoadingData(shimmer.quantity, columns) : data;

export default getParsedData;
